
import useGncHistory from '../../../hooks/useGncHistory'

const CancelButton = (props) => {
    const label = props.label || "Cancel"
    const navigateOverride = props.navigateOverride || null
    
    const {
        goBack,
    } = useGncHistory()
    
    const handleCancel = (event) => {
        event.preventDefault()
        if( navigateOverride ) {
            navigateOverride()
        } else {
            goBack()
        }
    }

    return (
        <button className="btn btn-white btn-mr" type="button" onClick={handleCancel}>{label}</button>
    )
}

export default CancelButton
